/* eslint-disable react-hooks/exhaustive-deps */
import { ActiveProps, LayoutOne } from "../../components/Layout/CommonStyle";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { apiGet } from "../../components/Common/Axios";
import toast from "react-hot-toast";
import {
  Department,
  DepartmentInter,
  DepartmentMajor,
  DepartmentName,
} from "lib/models";

function UniversityMain() {
  const [majors, setMajors] = useState<DepartmentMajor[]>([]);
  const [selectedMajor, setSelectedMajor] = useState<
    DepartmentMajor | undefined
  >(undefined);
  const [inters, setInters] = useState<DepartmentInter[]>([]);
  const [selectedInter, setSelectedInter] = useState<
    DepartmentInter | undefined
  >(undefined);
  const [minors, setMinors] = useState<DepartmentInter[]>([]);
  const [selectedMinor, setSelectedMinor] = useState<
    DepartmentInter | undefined
  >(undefined);
  const [names, setNames] = useState<DepartmentName[]>([]);
  const [selectedName, setSelectedName] = useState<DepartmentName | undefined>(
    undefined
  );
  const [departments, setDepartments] = useState<Department[]>([]);
  // const [selectedDepartment, setSelectedDepartment] = useState<
  //   Department | undefined
  // >(undefined);

  // Major
  const loadMajor = async () => {
    const response = await apiGet("/university/department_major");
    if (response.error) {
      toast.error("학과 목록을 불러오는데 실패했습니다.");
      console.error("loadMajor.error", response.error);
      return;
    }

    setMajors(response.data);
    setSelectedMajor(response.data[0]);
  };

  useEffect(() => {
    loadMajor();
  }, []);

  // Inter
  const loadInter = async (majorId: number) => {
    const response = await apiGet(`/university/department_inter/${majorId}`);
    if (response.error) {
      toast.error("학과 목록을 불러오는데 실패했습니다.");
      console.error("loadInter.error", response.error);
      return;
    }
    setInters(response.data);
    setSelectedInter(response.data[0]);
  };

  useEffect(() => {
    if (!selectedMajor) return;
    loadInter(selectedMajor.id);
  }, [selectedMajor]);

  // Minor
  const loadMinor = async (majorId: number, interId: number) => {
    const response = await apiGet(
      `/university/department_minor/${majorId}/${interId}`
    );
    if (response.error) {
      toast.error("학과 목록을 불러오는데 실패했습니다.");
      console.error("loadMinor.error", response.error);
      return;
    }
    setMinors(response.data);
    setSelectedMinor(response.data[0]);
  };

  useEffect(() => {
    if (!selectedMajor || !selectedInter) return;
    loadMinor(selectedMajor?.id, selectedInter.id);
  }, [selectedInter]);

  // Name
  const loadName = async (
    majorId: number,
    interId: number,
    minorId: number
  ) => {
    const response = await apiGet(
      `/university/department_name/${majorId}/${interId}/${minorId}`
    );
    if (response.error) {
      toast.error("학과 목록을 불러오는데 실패했습니다.");
      console.error("loadName.error", response.error);
      return;
    }
    setNames(response.data);
    setSelectedName(response.data[0]);
  };

  useEffect(() => {
    if (!selectedMajor || !selectedInter || !selectedMinor) return;
    loadName(selectedMajor?.id, selectedInter.id, selectedMinor.id);
  }, [selectedMinor]);

  // Department
  const loadDepartment = async (
    majorId: number,
    interId: number,
    minorId: number,
    nameId: number
  ) => {
    const response = await apiGet(
      `/university/department/${majorId}/${interId}/${minorId}/${nameId}`
    );
    if (response.error) {
      toast.error("학과 목록을 불러오는데 실패했습니다.");
      console.error("loadDepartment.error", response.error);
      return;
    }
    setDepartments(response.data);
    //setSelectedDepartment(response.data[0]);
  };

  useEffect(() => {
    if (!selectedMajor || !selectedInter || !selectedMinor || !selectedName)
      return;
    loadDepartment(
      selectedMajor?.id,
      selectedInter.id,
      selectedMinor.id,
      selectedName.id
    );
  }, [selectedName]);

  return (
    <LayoutOne>
      <Content>
        <DataList>
          {majors.map((major) => (
            <DataItem
              key={major.id}
              active={major === selectedMajor}
              onClick={() => setSelectedMajor(major)}
            >
              {major.name}
            </DataItem>
          ))}
        </DataList>
        <DataList>
          {inters.map((inter) => (
            <DataItem
              key={inter.id}
              active={inter === selectedInter}
              onClick={() => setSelectedInter(inter)}
            >
              {inter.name}
            </DataItem>
          ))}
        </DataList>
        <DataList>
          {minors.map((minor) => (
            <DataItem
              key={minor.id}
              active={minor === selectedMinor}
              onClick={() => setSelectedMinor(minor)}
            >
              {minor.name}
            </DataItem>
          ))}
        </DataList>
        <DataList>
          {names.map((name) => (
            <DataItem
              key={name.id}
              active={name === selectedName}
              onClick={() => setSelectedName(name)}
            >
              {name.name}
            </DataItem>
          ))}
        </DataList>
      </Content>
      <DepartmentList>
        <TitleLine>
          <div>학교이름</div>
          <div>주소</div>
          <div>과이름</div>
          <div>주/야</div>
          <div>정원</div>
          <div>모집</div>
          <div>지원(남/여/전체)</div>
          <div>입학(남/여/전체)</div>
          <div>졸업(남/여/전체)</div>
        </TitleLine>
        {departments.map((department) => (
          <DataLine key={department.id}>
            <div>{department.university.name}</div>
            <div>{department.campus.address}</div>
            <div>{department.name}</div>
            <div>{department.dayNight}</div>
            <div>{department.inQuota}</div>
            <div>{department.inRecruit}</div>
            <div>
              {department.applicantM} / {department.applicantF} /&nbsp;
              {department.applicant}
            </div>
            <div>
              {department.admissionM} / {department.admissionF} /&nbsp;
              {department.admission}
            </div>
            <div>
              {department.graduationM} / {department.graduationF} /&nbsp;
              {department.graduation}
            </div>
            <div></div>
          </DataLine>
        ))}
      </DepartmentList>
    </LayoutOne>
  );
}

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 13px;
  font-size: 1rem;
`;
const DataList = styled.div`
  border: 1px solid lightgray;
  border-radius: 10px;
  background-color: white;
  height: 300px; /* or max-height: 300px; */
  overflow-y: auto;

  & > div:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  & > div:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;
const DataItem = styled.div`
  padding: 5px 10px;
  cursor: pointer;
  background-color: ${(props: ActiveProps) =>
    props.active ? "tomato" : "white"};
  color: ${(props: ActiveProps) => (props.active ? "white" : "black")};

  &:hover {
    background-color: ${(props: ActiveProps) =>
      props.active ? "tomato" : "lightblue"};
    color: ${(props: ActiveProps) => (props.active ? "white" : "black")};
  }
`;

const DepartmentList = styled.div``;
const TitleLine = styled.div`
  display: grid;
  grid-template-columns: 200px 500px 200px 80px repeat(8, 120px);
  align-items: center;
  padding: 25px 0 25px 30px;

  & > div:nth-child(1),
  & > div:nth-child(2),
  & > div:nth-child(3),
  & > div:nth-child(4) {
    text-align: left;
    text-overflow: ellipsis;
    padding: 0 2px;
  }

  & > div:nth-child(5),
  & > div:nth-child(6),
  & > div:nth-child(7),
  & > div:nth-child(8),
  & > div:nth-child(9),
  & > div:nth-child(10),
  & > div:nth-child(11),
  & > div:nth-child(12) {
    text-align: center;
  }
`;
const DataLine = styled.div`
  display: grid;
  grid-template-columns: 200px 500px 200px 80px repeat(8, 120px);
  align-items: center;
  padding: 13px 0 13px 30px;
  background-color: white;
  margin-bottom: 10px;
  border-radius: 15px;
  cursor: pointer;

  & > div {
    background-color: white;
  }

  & > div:nth-child(1),
  & > div:nth-child(2),
  & > div:nth-child(3),
  & > div:nth-child(4) {
    text-align: left;
    text-overflow: ellipsis;
    padding: 0 2px;
  }

  & > div:nth-child(5),
  & > div:nth-child(6),
  & > div:nth-child(7),
  & > div:nth-child(8),
  & > div:nth-child(9),
  & > div:nth-child(10),
  & > div:nth-child(11),
  & > div:nth-child(12) {
    text-align: center;
  }
`;
export default UniversityMain;
